export const IconInfor = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.16675 13.166H9.83341V8.16602H8.16675V13.166ZM9.00008 6.49935C9.23619 6.49935 9.43425 6.41935 9.59425 6.25935C9.75369 6.0999 9.83341 5.90213 9.83341 5.66602C9.83341 5.4299 9.75369 5.23185 9.59425 5.07185C9.43425 4.9124 9.23619 4.83268 9.00008 4.83268C8.76397 4.83268 8.56619 4.9124 8.40675 5.07185C8.24675 5.23185 8.16675 5.4299 8.16675 5.66602C8.16675 5.90213 8.24675 6.0999 8.40675 6.25935C8.56619 6.41935 8.76397 6.49935 9.00008 6.49935ZM9.00008 17.3327C7.8473 17.3327 6.76397 17.1138 5.75008 16.676C4.73619 16.2388 3.85425 15.6452 3.10425 14.8952C2.35425 14.1452 1.76064 13.2632 1.32341 12.2493C0.885637 11.2355 0.666748 10.1521 0.666748 8.99935C0.666748 7.84657 0.885637 6.76324 1.32341 5.74935C1.76064 4.73546 2.35425 3.85352 3.10425 3.10352C3.85425 2.35352 4.73619 1.75963 5.75008 1.32185C6.76397 0.884627 7.8473 0.666016 9.00008 0.666016C10.1529 0.666016 11.2362 0.884627 12.2501 1.32185C13.264 1.75963 14.1459 2.35352 14.8959 3.10352C15.6459 3.85352 16.2395 4.73546 16.6767 5.74935C17.1145 6.76324 17.3334 7.84657 17.3334 8.99935C17.3334 10.1521 17.1145 11.2355 16.6767 12.2493C16.2395 13.2632 15.6459 14.1452 14.8959 14.8952C14.1459 15.6452 13.264 16.2388 12.2501 16.676C11.2362 17.1138 10.1529 17.3327 9.00008 17.3327ZM9.00008 15.666C10.8612 15.666 12.4376 15.0202 13.7292 13.7285C15.0209 12.4368 15.6667 10.8605 15.6667 8.99935C15.6667 7.13824 15.0209 5.56185 13.7292 4.27018C12.4376 2.97852 10.8612 2.33268 9.00008 2.33268C7.13897 2.33268 5.56258 2.97852 4.27091 4.27018C2.97925 5.56185 2.33341 7.13824 2.33341 8.99935C2.33341 10.8605 2.97925 12.4368 4.27091 13.7285C5.56258 15.0202 7.13897 15.666 9.00008 15.666Z"
      fill="#1C1B1F"
    />
  </svg>
);

export const IconChart = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.16667 15.5C1.70833 15.5 1.31583 15.3369 0.989167 15.0108C0.663055 14.6842 0.5 14.2917 0.5 13.8333V2.16667C0.5 1.70833 0.663055 1.31583 0.989167 0.989167C1.31583 0.663055 1.70833 0.5 2.16667 0.5H9.66667V2.16667H2.16667V13.8333H13.8333V6.33333H15.5V13.8333C15.5 14.2917 15.3369 14.6842 15.0108 15.0108C14.6842 15.3369 14.2917 15.5 13.8333 15.5H2.16667ZM3.83333 12.1667H5.5V6.33333H3.83333V12.1667ZM7.16667 12.1667H8.83333V3.83333H7.16667V12.1667ZM10.5 12.1667H12.1667V8.83333H10.5V12.1667ZM12.1667 5.5V3.83333H10.5V2.16667H12.1667V0.5H13.8333V2.16667H15.5V3.83333H13.8333V5.5H12.1667Z"
      fill="black"
    />
  </svg>
);

export const IconEmpty = () => (
  <svg
    width="74"
    height="33"
    viewBox="0 0 74 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11525_31932)">
      <rect x="22.5" y="13" width="29" height="19" fill="#EDEDED" />
      <path
        d="M22 8.5H52"
        stroke="#C0C0C0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52 8.5L45 2.5H29L22 8.5V32.5H52V8.5Z"
        stroke="#C0C0C0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41 18.5H33V8.5L36 2.5H38L41 8.5V18.5Z"
        stroke="#C0C0C0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <line x1="54.5" y1="31" x2="65.5" y2="31" stroke="black" strokeWidth="2" />
    <line x1="8.5" y1="32" x2="19.5" y2="32" stroke="black" strokeWidth="2" />
    <line x1="0.5" y1="32" x2="4.5" y2="32" stroke="black" strokeWidth="2" />
    <line x1="68.5" y1="31" x2="73.5" y2="31" stroke="black" strokeWidth="2" />
    <g clipPath="url(#clip1_11525_31932)">
      <path
        d="M53.5 0C49.089 0 45.5 3.589 45.5 8C45.5 12.411 49.089 16 53.5 16C57.911 16 61.5 12.411 61.5 8C61.5 3.589 57.911 0 53.5 0ZM54.4645 3.5L54 9.5H53L52.5355 3.5H54.4645ZM53.5 12.5C52.9475 12.5 52.5 12.0525 52.5 11.5C52.5 10.9475 52.9475 10.5 53.5 10.5C54.0525 10.5 54.5 10.9475 54.5 11.5C54.5 12.0525 54.0525 12.5 53.5 12.5Z"
        fill="#F0B71C"
      />
    </g>
    <defs>
      <clipPath id="clip0_11525_31932">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(20.5 1)"
        />
      </clipPath>
      <clipPath id="clip1_11525_31932">
        <rect width="16" height="16" fill="white" transform="translate(45.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const AddIconInfor = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00004 0.833984C5.6815 0.833984 4.39257 1.22498 3.29624 1.95752C2.19991 2.69006 1.34543 3.73125 0.840847 4.94943C0.336263 6.1676 0.20424 7.50805 0.461475 8.80125C0.71871 10.0945 1.35365 11.2823 2.286 12.2147C3.21835 13.147 4.40624 13.782 5.69944 14.0392C6.99265 14.2965 8.33309 14.1644 9.55127 13.6598C10.7694 13.1553 11.8106 12.3008 12.5432 11.2045C13.2757 10.1081 13.6667 8.81919 13.6667 7.50065C13.6667 6.62517 13.4943 5.75827 13.1592 4.94943C12.8242 4.14059 12.3331 3.40566 11.7141 2.78661C11.095 2.16755 10.3601 1.67649 9.55127 1.34145C8.74243 1.00642 7.87552 0.833984 7.00004 0.833984ZM7.00004 11.5007C6.86819 11.5007 6.7393 11.4616 6.62966 11.3883C6.52003 11.315 6.43458 11.2109 6.38412 11.0891C6.33367 10.9673 6.32046 10.8332 6.34619 10.7039C6.37191 10.5746 6.4354 10.4558 6.52864 10.3626C6.62187 10.2693 6.74066 10.2059 6.86998 10.1801C6.9993 10.1544 7.13335 10.1676 7.25517 10.2181C7.37698 10.2685 7.4811 10.354 7.55436 10.4636C7.62761 10.5732 7.66671 10.7021 7.66671 10.834C7.66671 11.0108 7.59647 11.1804 7.47145 11.3054C7.34642 11.4304 7.17686 11.5007 7.00004 11.5007ZM7.66671 8.16732C7.66671 8.34413 7.59647 8.5137 7.47145 8.63872C7.34642 8.76375 7.17686 8.83398 7.00004 8.83398C6.82323 8.83398 6.65366 8.76375 6.52864 8.63872C6.40362 8.5137 6.33338 8.34413 6.33338 8.16732V4.16732C6.33338 3.99051 6.40362 3.82094 6.52864 3.69591C6.65366 3.57089 6.82323 3.50065 7.00004 3.50065C7.17686 3.50065 7.34642 3.57089 7.47145 3.69591C7.59647 3.82094 7.66671 3.99051 7.66671 4.16732V8.16732Z"
      fill="#47C751"
    />
  </svg>
);

export const QuestionIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.00866568 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C40 17.3736 39.4827 14.7728 38.4776 12.3463C37.4725 9.91982 35.9993 7.71504 34.1421 5.85786C32.285 4.00069 30.0802 2.5275 27.6537 1.52241C25.2272 0.517315 22.6264 0 20 0ZM20 32C19.6044 32 19.2178 31.8827 18.8889 31.6629C18.56 31.4432 18.3036 31.1308 18.1523 30.7654C18.0009 30.3999 17.9613 29.9978 18.0384 29.6098C18.1156 29.2219 18.3061 28.8655 18.5858 28.5858C18.8655 28.3061 19.2219 28.1156 19.6098 28.0384C19.9978 27.9613 20.3999 28.0009 20.7654 28.1522C21.1308 28.3036 21.4432 28.56 21.6629 28.8889C21.8827 29.2178 22 29.6044 22 30C22 30.5304 21.7893 31.0391 21.4142 31.4142C21.0392 31.7893 20.5304 32 20 32ZM23.42 22.78C22 23.46 22 23.56 22 24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0392 25.7893 20.5304 26 20 26C19.4696 26 18.9609 25.7893 18.5858 25.4142C18.2107 25.0391 18 24.5304 18 24C18.028 22.9092 18.3985 21.8547 19.0589 20.9861C19.7194 20.1175 20.6364 19.4786 21.68 19.16C23.22 18.42 24 18 24 16C23.9999 15.6529 23.9096 15.3118 23.7377 15.0102C23.5659 14.7087 23.3186 14.457 23.02 14.28C22.1067 13.7413 21.06 13.4709 20 13.5C18.62 13.5 16 14.02 16 16C16 16.5304 15.7893 17.0391 15.4142 17.4142C15.0391 17.7893 14.5304 18 14 18C13.4696 18 12.9609 17.7893 12.5858 17.4142C12.2107 17.0391 12 16.5304 12 16C12 12.24 15.36 9.5 20 9.5C24.64 9.5 28 12.24 28 16C28.0726 17.4734 27.6654 18.9307 26.8397 20.1531C26.0139 21.3755 24.814 22.2973 23.42 22.78Z"
      fill="#17345B"
    />
  </svg>
);

export const IconUpload = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <mask
      id="mask0_357_14003"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="5"
      width="14"
      height="11"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.3335 5.86279H14.6666V15.0239H1.3335V5.86279Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_357_14003)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7102 15.0239H4.29016C2.66016 15.0239 1.3335 13.6981 1.3335 12.0677V8.81828C1.3335 7.18856 2.66016 5.86279 4.29016 5.86279H4.91216C5.18816 5.86279 5.41216 6.08675 5.41216 6.36271C5.41216 6.63866 5.18816 6.86262 4.91216 6.86262H4.29016C3.21083 6.86262 2.3335 7.7398 2.3335 8.81828V12.0677C2.3335 13.1469 3.21083 14.024 4.29016 14.024H11.7102C12.7888 14.024 13.6668 13.1469 13.6668 12.0677V8.81228C13.6668 7.73713 12.7922 6.86262 11.7175 6.86262H11.0888C10.8128 6.86262 10.5888 6.63866 10.5888 6.36271C10.5888 6.08675 10.8128 5.86279 11.0888 5.86279H11.7175C13.3435 5.86279 14.6668 7.1859 14.6668 8.81228V12.0677C14.6668 13.6981 13.3402 15.0239 11.7102 15.0239Z"
        fill="black"
      />
    </g>
    <mask
      id="mask1_357_14003"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="7"
      y="1"
      width="2"
      height="10"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 1.33447H8.5V10.3602H7.5V1.33447Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_357_14003)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 10.3602C7.724 10.3602 7.5 10.1363 7.5 9.86032V1.83439C7.5 1.55843 7.724 1.33447 8 1.33447C8.276 1.33447 8.5 1.55843 8.5 1.83439V9.86032C8.5 10.1363 8.276 10.3602 8 10.3602Z"
        fill="black"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.05648 4.28647C5.92914 4.28647 5.80114 4.23781 5.70381 4.1405C5.50848 3.94587 5.50714 3.62992 5.70248 3.43395L7.64581 1.4823C7.83314 1.29366 8.16648 1.29366 8.35381 1.4823L10.2978 3.43395C10.4925 3.62992 10.4918 3.94587 10.2965 4.1405C10.1005 4.33513 9.78448 4.33513 9.58981 4.13917L7.99981 2.54344L6.41048 4.13917C6.31314 4.23781 6.18448 4.28647 6.05648 4.28647Z"
      fill="black"
    />
  </svg>
);

export const IconExcel = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.77783 0.888672V15.9998H14.2223V4.72457L14.0356 4.55021L10.3023 1.06303L10.1156 0.888672H1.77783ZM3.02228 2.05106H9.2445V5.53824H12.9778V14.8374H3.02228V2.05106ZM10.4889 2.86474L12.1067 4.37585H10.4889V2.86474ZM4.88894 6.70064L7.25339 9.89722L4.88894 13.0938H6.38228L8.00005 10.8853L9.61783 13.0938H11.1112L8.74672 9.89722L11.1112 6.70064H9.61783L8.00005 8.90918L6.38228 6.70064H4.88894Z"
      fill="black"
    />
  </svg>
);

export const IconAdd = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
  >
    <g clipPath="url(#clip0_291_11373)">
      <path
        d="M6.25 1.75V11.75"
        stroke="#7A7A7A"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M11.25 6.75H1.25"
        stroke="#7A7A7A"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
    <defs>
      <clipPath id="clip0_291_11373">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconDownloadOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.58325 1.36574C9.2677 1.3209 8.84461 1.31789 8.11039 1.31789H7.75C6.32165 1.31789 5.30069 1.31896 4.52481 1.42327C3.76331 1.52565 3.31319 1.71917 2.98223 2.05013C2.65128 2.38108 2.45776 2.8312 2.35538 3.5927C2.25106 4.36859 2.25 5.38955 2.25 6.8179V9.11286C2.25 10.5412 2.25106 11.5622 2.35538 12.338C2.45776 13.0995 2.65128 13.5497 2.98223 13.8806C3.31319 14.2116 3.76331 14.4051 4.52481 14.5075C5.30069 14.6118 6.32165 14.6129 7.75 14.6129C9.17835 14.6129 10.1993 14.6118 10.9752 14.5075C11.7367 14.4051 12.1868 14.2116 12.5178 13.8806C12.8487 13.5497 13.0422 13.0995 13.1446 12.338C13.2489 11.5622 13.25 10.5412 13.25 9.11286V6.45751C13.25 5.95346 13.2486 5.58142 13.2347 5.28861C12.703 5.28807 12.2634 5.28363 11.9007 5.24875C11.4717 5.2075 11.0982 5.12008 10.7632 4.91179C10.4375 4.70929 10.1628 4.43457 9.96024 4.1089C9.75194 3.77392 9.66451 3.40042 9.62325 2.97141C9.58324 2.55547 9.58325 2.03851 9.58325 1.39748V1.39747V1.37206V1.36574ZM10.5837 1.78875C10.5852 2.2463 10.5915 2.59326 10.6187 2.87566C10.6528 3.23051 10.7162 3.43081 10.8094 3.58083C10.931 3.77624 11.0958 3.94107 11.2912 4.06257C11.4412 4.15585 11.6415 4.21922 11.9964 4.25334C12.2685 4.27951 12.6007 4.28632 13.034 4.28808C13.0196 4.25578 13.0045 4.22378 12.9888 4.19212C12.7945 3.80119 12.4635 3.48424 11.6035 2.68739C11.1272 2.24606 10.8278 1.97185 10.5837 1.78875ZM12.2831 1.95385L12.2176 1.89312C11.5312 1.2569 11.099 0.856313 10.5677 0.619979C10.472 0.577408 10.3744 0.539155 10.2753 0.505335C9.72492 0.317586 9.13564 0.317701 8.19973 0.317882L8.11039 0.317894H7.75L7.71204 0.317894C6.33001 0.317884 5.24179 0.317877 4.39156 0.432187C3.51918 0.549477 2.82285 0.795296 2.27513 1.34302C1.7274 1.89074 1.48158 2.58707 1.36429 3.45946C1.24998 4.30969 1.24999 5.3979 1.25 6.77993V6.77993V6.8179V9.11286V9.15082C1.24999 10.5328 1.24998 11.6211 1.36429 12.4713C1.48158 13.3437 1.7274 14.04 2.27513 14.5877C2.82285 15.1355 3.51918 15.3813 4.39156 15.4986C5.2418 15.6129 6.33002 15.6129 7.71205 15.6129H7.75H7.78795C9.16998 15.6129 10.2582 15.6129 11.1084 15.4986C11.9808 15.3813 12.6771 15.1355 13.2249 14.5877C13.7726 14.04 14.0184 13.3437 14.1357 12.4713C14.25 11.6211 14.25 10.5329 14.25 9.15084V9.11286V6.45751L14.25 6.35785C14.2502 5.3189 14.2504 4.66467 14.0228 4.06425C13.9819 3.9563 13.9357 3.85045 13.8843 3.74707C13.5985 3.17206 13.1185 2.72752 12.3563 2.02157L12.2831 1.95385ZM7.66667 11.5151C7.88831 11.5151 8.0986 11.4171 8.2411 11.2473L9.90777 9.26194C10.1741 8.94469 10.1328 8.47161 9.81554 8.20529C9.49829 7.93897 9.02522 7.98026 8.7589 8.29751L8.41667 8.7052V6.00015C8.41667 5.58593 8.08088 5.25015 7.66667 5.25015C7.25245 5.25015 6.91667 5.58593 6.91667 6.00015V8.7052L6.57443 8.29751C6.30811 7.98026 5.83504 7.93897 5.51779 8.20529C5.20054 8.47161 5.15925 8.94469 5.42557 9.26194L7.09223 11.2473C7.23474 11.4171 7.44503 11.5151 7.66667 11.5151Z"
      fill="black"
    />
  </svg>
);

export const IconCalculatePoints = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M5 0.250003L4.948 0.250001H4.94797C4.04951 0.249973 3.3003 0.249949 2.70552 0.329915C2.07773 0.414319 1.51093 0.59999 1.05546 1.05546C0.59999 1.51093 0.414319 2.07773 0.329915 2.70552C0.249949 3.3003 0.249973 4.04951 0.250001 4.94797V4.948L0.250003 5V7L0.250001 7.052V7.05203C0.249973 7.9505 0.249949 8.69971 0.329915 9.29448C0.414319 9.92228 0.59999 10.4891 1.05546 10.9445C1.51093 11.4 2.07773 11.5857 2.70552 11.6701C3.30029 11.7501 4.04949 11.75 4.94795 11.75H4.94798L5 11.75H7L7.05203 11.75H7.05206C7.95051 11.75 8.69971 11.7501 9.29448 11.6701C9.92228 11.5857 10.4891 11.4 10.9445 10.9445C11.4 10.4891 11.5857 9.92228 11.6701 9.29448C11.7501 8.69971 11.75 7.95051 11.75 7.05206V7.05203L11.75 7V5.44445C11.75 5.03023 11.4142 4.69445 11 4.69445C10.5858 4.69445 10.25 5.03023 10.25 5.44445V7C10.25 7.96402 10.2484 8.61158 10.1835 9.09461C10.1214 9.55607 10.0142 9.75357 9.88389 9.88389C9.75357 10.0142 9.55607 10.1214 9.09461 10.1835C8.61158 10.2484 7.96402 10.25 7 10.25H5C4.03599 10.25 3.38843 10.2484 2.9054 10.1835C2.44393 10.1214 2.24644 10.0142 2.11612 9.88389C1.9858 9.75357 1.87858 9.55607 1.81654 9.09461C1.7516 8.61158 1.75 7.96402 1.75 7V5C1.75 4.03599 1.7516 3.38843 1.81654 2.9054C1.87858 2.44393 1.9858 2.24644 2.11612 2.11612C2.24644 1.9858 2.44393 1.87858 2.9054 1.81654C3.38843 1.7516 4.03599 1.75 5 1.75H8.22223C8.63644 1.75 8.97223 1.41422 8.97223 1C8.97223 0.58579 8.63644 0.250003 8.22223 0.250003H5ZM11.0303 3.03034C11.3232 2.73744 11.3232 2.26257 11.0303 1.96968C10.7374 1.67678 10.2626 1.67678 9.96968 1.96968L6.00001 5.93935L5.03034 4.96968C4.73744 4.67678 4.26257 4.67678 3.96968 4.96968C3.67678 5.26257 3.67678 5.73744 3.96968 6.03034L5.46968 7.53034C5.61033 7.67099 5.8011 7.75001 6.00001 7.75001C6.19892 7.75001 6.38969 7.67099 6.53034 7.53034L11.0303 3.03034Z"
      fill="black"
    />
  </svg>
);
